// Real screen with a way back rather than a blank page — more state is addressable now
// (tabs, log channels, filters, jobs), so there are more URLs an operator can hand-edit or bookmark.
import { Link } from '@tanstack/react-router';

const ID = 'em-mgr--not-found';

export function NotFoundRoute() {
  return (
    <section
      data-id={ID}
      className="mx-auto max-w-md space-y-3 rounded-lg border border-dashed border-slate-300 p-8 text-center dark:border-slate-700"
    >
      <h2 data-id={`${ID}--title`} className="text-lg font-semibold">
        Page not found
      </h2>
      <p data-id={`${ID}--body`} className="text-sm text-slate-500 dark:text-slate-400">
        That address doesn’t match anything in the manager.
      </p>
      <Link
        to="/"
        data-id={`${ID}--home`}
        className="inline-block rounded-md bg-slate-900 px-3 py-1.5 text-sm font-medium text-white hover:bg-slate-700 dark:bg-slate-100 dark:text-slate-900 dark:hover:bg-slate-300"
      >
        Back to the fleet
      </Link>
    </section>
  );
}
